import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { addProductToCart, removeProductFromCart } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { Session } from "@insite/client-framework/Services/SessionService";
import { BannerCarouselList } from "@NA/Services/GetBannerCarousel";
import { getPrice, getUnitNetPrice } from "@NA/Overrides/Services/ProductPriceService";
import { CartItemsListDto } from "@NA/Types/GtmModel";
import { CoveoProductModel } from "@NA/Types/CoveoModel";

export function getProductMarketingTag(product: ProductModel) {
    if (
        product.pricing !== undefined &&
        product.pricing != null &&
        product.pricing.unitListPrice <= product.pricing.unitRegularPrice &&
        product.properties["saletype"] !== "HD" &&
        product.properties["saletype"] !== "EV" &&
        product.properties["saletype"] !== "SM" &&
        product.properties["saletype"] !== "ED" &&
        product.properties["saletype"] !== "CD" &&
        product.properties["saletype"] !== "DD" &&
        product.properties["saletype"] !== "WS" &&
        product.properties["saletype"] !== "OO" &&
        product.properties["saletype"] !== "SD" &&
        product.properties["saletype"] !== "LT" &&
        product.properties["saletype"] !== "FS" &&
        product.properties["saletype"] !== "BF" &&
        (product.properties["classificatioN_CODE"] === "x" || product.properties["classificatioN_CODE"] === "X")
    ) {
        return "Clearance";
    }
    if (
        product.properties["saletype"] !== "ED" &&
        product.properties["saletype"] !== "EV" &&
        product.properties["saletype"] !== "SM" &&
        product.properties["saletype"] !== "CD" &&
        product.properties["saletype"] !== "DD" &&
        product.properties["saletype"] !== "WS" &&
        product.properties["saletype"] !== "OO" &&
        product.properties["saletype"] !== "SD" &&
        product.properties["saletype"] !== "LT" &&
        product.properties["saletype"] !== "FS" &&
        product.properties["saletype"] !== "BF" &&
        product.properties["saletype"] !== "HD" &&
        product.properties["classificatioN_CODE"] !== "X" &&
        product.properties["onsalenow"] === "1"
    ) {
        return "Sale";
    }
    if (product.properties["saletype"] === "HD") {
        return "Hot Deal";
    }
    if (product.properties["saletype"] === "BF") {
        return "Black Friday";
    }
    if (product.properties["saletype"] === "FS") {
        return "Flash Sale";
    }
    if (product.properties["saletype"] === "LT") {
        return "Limited Time";
    }
    if (product.properties["saletype"] === "SD") {
        return "Special Deal";
    }
    if (product.properties["saletype"] === "WS" || product.properties["saletype"] === "OO") {
        return "Online Only";
    }
    if (product.properties["saletype"] === "DD") {
        return "Daily Deal";
    }
    if (product.properties["saletype"] === "CD") {
        return "Cyber Deal";
    }
    if (product.properties["saletype"] === "ED") {
        return "Expo Deal";
    }
    if (product.properties["saletype"] === "EV") {
        return "Everyday Value";
    }
    if (product.properties["saletype"] === "SM") {
        return "Save More";
    }

    if (
        product.properties["saletype"] !== "EV" &&
        product.properties["saletype"] !== "SM" &&
        product.properties["saletype"] !== "ED" &&
        product.properties["saletype"] !== "CD" &&
        product.properties["saletype"] !== "DD" &&
        product.properties["saletype"] !== "WS" &&
        product.properties["saletype"] !== "OO" &&
        product.properties["saletype"] !== "SD" &&
        product.properties["saletype"] !== "LT" &&
        product.properties["saletype"] !== "FS" &&
        product.properties["saletype"] !== "BF" &&
        product.properties["saletype"] !== "HD" &&
        product.properties["classificatioN_CODE"] !== "X" &&
        product.properties["onsalenow"] !== "1" &&
        product.properties["isnewproduct"] === "NP"
    ) {
        return "New";
    } else {
        return "Regular";
    }
}


export function getProductMarketingTagCoveo(product: CoveoProductModel) {
    if (
        product.pricing !== undefined &&
        product.pricing != null &&
        product.pricing.unitListPrice <= product.pricing.unitRegularPrice &&
        product.saleType !== "HD" &&
        product.saleType !== "EV" &&
        product.saleType !== "SM" &&
        product.saleType !== "ED" &&
        product.saleType !== "CD" &&
        product.saleType !== "DD" &&
        product.saleType !== "WS" &&
        product.saleType !== "OO" &&
        product.saleType !== "SD" &&
        product.saleType !== "LT" &&
        product.saleType !== "FS" &&
        product.saleType !== "BF" &&
        (product.classificatioN_CODE === "x" || product.classificatioN_CODE === "X")
    ) {
        return "Clearance";
    }
    if (
        product.saleType !== "ED" &&
        product.saleType !== "EV" &&
        product.saleType !== "SM" &&
        product.saleType !== "CD" &&
        product.saleType !== "DD" &&
        product.saleType !== "WS" &&
        product.saleType !== "OO" &&
        product.saleType !== "SD" &&
        product.saleType !== "LT" &&
        product.saleType !== "FS" &&
        product.saleType !== "BF" &&
        product.saleType !== "HD" &&
        product.classificatioN_CODE !== "X" &&
        product.onSaleNow === "1"
    ) {
        return "Sale";
    }
    if (product.saleType === "HD") {
        return "Hot Deal";
    }
    if (product.saleType === "BF") {
        return "Black Friday";
    }
    if (product.saleType === "FS") {
        return "Flash Sale";
    }
    if (product.saleType === "LT") {
        return "Limited Time";
    }
    if (product.saleType === "SD") {
        return "Special Deal";
    }
    if (product.saleType === "WS" || product.saleType === "OO") {
        return "Online Only";
    }
    if (product.saleType === "DD") {
        return "Daily Deal";
    }
    if (product.saleType === "CD") {
        return "Cyber Deal";
    }
    if (product.saleType === "ED") {
        return "Expo Deal";
    }
    if (product.saleType === "EV") {
        return "Everyday Value";
    }
    if (product.saleType === "SM") {
        return "Save More";
    }

    if (
        product.saleType !== "EV" &&
        product.saleType !== "SM" &&
        product.saleType !== "ED" &&
        product.saleType !== "CD" &&
        product.saleType !== "DD" &&
        product.saleType !== "WS" &&
        product.saleType !== "OO" &&
        product.saleType !== "SD" &&
        product.saleType !== "LT" &&
        product.saleType !== "FS" &&
        product.saleType !== "BF" &&
        product.saleType !== "HD" &&
        product.classificatioN_CODE !== "X" &&
        product.onSaleNow !== "1" &&
        product.isNewProduct === "NP"
    ) {
        return "New";
    } else {
        return "Regular";
    }
}

export function createDataLayerItemCoveo(    
    product: any,
    categories: string[],
    listname: string,
    productIndex = 0,
    itemvariant = "",
    price = 0,
): any {
    if (product !== null && product !== undefined) {
        const brand = product?.brandName;
        const qty =  product?.minimumOrderQty;  
        const price_type = product?.additionalFields?.ec_onsalenow;      
        const priceDisp = getPrice(
            product?.pricing?.unitRegularBreakPrices,
            product?.pricing?.unitNetPrice,
            product?.pricing?.unitNetPriceDisplay,
            qty,
        );
        return {
            item_id:
                product?.erpNumber !== undefined && product?.erpNumber != null
                    ? product.erpNumber.trim()
                    : product.productNumber,
            item_name:
                product.shortDescription !== undefined && product.shortDescription != null
                    ? product.shortDescription
                    : product.productTitle,
            item_brand: brand,
            item_category: categories.length > 0 ? categories[0] : "",
            item_category2: categories.length > 1 ? categories[1] : "",
            item_category3: categories.length > 2 ? categories[2] : "",
            item_variant: itemvariant, // product.availability != null && product.availability["message"] != null ? product.availability["message"] : '',
            item_list_name: listname,
            index: productIndex + 1,
            price: priceDisp,
            quantity: Number(qty),
            price_type: getProductMarketingTagCoveo(product),
            //price_type: "Regular",
        };
    }
}

export function createDataLayerItemAuth(
    product: any,
    categories: string[],
    listname: string,
    productIndex = 0,
    itemvariant = "",
    price = 0,
): any {
    if (product !== null && product !== undefined) {
        const brand = product.properties["branD_SHORTDESC"] ? product.properties["branD_SHORTDESC"] : product.brand?.name;
        const qty =
            product.qtyOrdered !== undefined && product.qtyOrdered != null && product.qtyOrdered !== 0
                ? product.qtyOrdered
                : product.properties["minimuM_QTY"] || 1;
        const priceDisp =
            price ||
            (product.pricing != null && product.pricing !== undefined
                ? getUnitNetPrice(product.pricing, qty).price
                : 0);
        return {
            item_id:
                product.erpNumber !== undefined && product.erpNumber != null
                    ? product.erpNumber.trim()
                    : product.productNumber,
            item_name:
                product.shortDescription !== undefined && product.shortDescription != null
                    ? product.shortDescription
                    : product.productTitle,
            item_brand: brand,
            item_category: categories.length > 0 ? categories[0] : "",
            item_category2: categories.length > 1 ? categories[1] : "",
            item_category3: categories.length > 2 ? categories[2] : product.properties["productcategory"] ?? "",
            item_variant: itemvariant, // product.availability != null && product.availability["message"] != null ? product.availability["message"] : '',
            item_list_name: listname,
            index: productIndex + 1,
            price: priceDisp,
            quantity: Number(qty),
            price_type: getProductMarketingTag(product),
        };
    }
}
export function createDataLayerItemAuthWithDiscount(
    product: any,
    categories: string[],
    listname: string,
    productIndex = 0,
    discount = "",
    itemvariant = "",
): any {
    if (product !== null && product !== undefined) {
        const brand = product.properties["branD_SHORTDESC"] ? product.properties["branD_SHORTDESC"] : product.brand?.name;
        const qty =
            product.qtyOrdered !== undefined && product.qtyOrdered != null && product.qtyOrdered !== 0
                ? product.qtyOrdered
                : product.properties["minimuM_QTY"] || 1;
        const priceDisp =
            product.pricing != null && product.pricing !== undefined
                ? getUnitNetPrice(product.pricing, qty).price
                : 0;
        return {
            item_id:
                product.erpNumber !== undefined && product.erpNumber != null
                    ? product.erpNumber.trim()
                    : product.productNumber,
            item_name:
                product.shortDescription !== undefined && product.shortDescription != null
                    ? product.shortDescription
                    : product.productTitle,
            item_brand: brand,
            item_category: categories.length > 0 ? categories[0] : "",
            item_category2: categories.length > 1 ? categories[1] : "",
            item_category3: categories.length > 2 ? categories[2] : product.properties["productcategory"] ?? "",
            item_variant: itemvariant,
            item_list_name: listname,
            index: productIndex + 1,
            price: priceDisp,
            discount: discount,
            quantity: Number(qty),
            price_type: getProductMarketingTag(product),
        };
    }
}

export function createDataLayerItemUnAuth(product: any, categories: string[], listname: string, productIndex = 0): any {    
    const brand = product?.brandName !== undefined && product?.brandName != null ? product?.brandName : product?.properties?.["branD_SHORTDESC"] ?? product?.brand?.name;
    if (product !== null && product !== undefined) {
        return {
            item_id:
                product.erpNumber !== undefined && product.erpNumber != null
                    ? product.erpNumber.trim()
                    : product.productNumber,
            item_name:
                product.shortDescription !== undefined && product.shortDescription != null
                    ? product.shortDescription
                    : product.productTitle,
            item_brand: brand,
            item_category: categories?.length > 0 ? categories[0] : "",
            item_category2: categories?.length > 1 ? categories[1] : "",
            item_category3: categories?.length > 2 ? categories[2] : "",
            item_list_name: listname,
            index: productIndex + 1,
        };
    }
}

export function addOrRemoveCart(cartLine: CartLineModel, inputQty: number, session: Session): void {
    if (cartLine && cartLine.qtyOrdered != null) {
        if (inputQty === 0) {
            const product: CartLineModel = cartLine;
            removeProductFromCart(product, "", session);
        } else if (inputQty > cartLine.qtyOrdered) {
            const product: CartLineModel = cartLine;
            // product.qtyOrdered = inputQty;
            addProductToCart(product, "", session);
        } else if (inputQty < cartLine.qtyOrdered) {
            const product: CartLineModel = cartLine;
            // product.qtyOrdered = inputQty;
            removeProductFromCart(product, "", session);
        }
    }
}

export function getGaTagforL1L2(title: string, tile: string, button: string): string {
    let categoryName = "";
    categoryName = findCategoryNameforL1L2();
    let gaTag = "";
    if (tile !== "" && button !== "") gaTag = `${categoryName}_${title}_${tile}_${button}`;
    else if (tile !== "" && button === "") gaTag = `${categoryName}_${title}_${tile}`;
    else if (tile === "" && button !== "") gaTag = `${categoryName}_${title}_${button}`;
    else gaTag = `${categoryName}_${title}`;

    gaTag = gaTag?.toLocaleLowerCase().trim();
    gaTag = gaTag?.replace(/[&)#($:.',;*]/g, "");
    gaTag = gaTag?.replace(/  /g, "-");
    gaTag = gaTag?.replace(/ /g, "-");
    gaTag = gaTag?.replace("--", "-");
    //gaTag = (gaTag?.toLocaleLowerCase())?.replace(/ /g,"-");
    return gaTag;
}

export function createInvoiceOrderLineDataLayerItemAuth(
    invoiceOrderLine: any,
    categories: string[],
    listname: string,
    productIndex = 0,
    discount = "",
): any {
    if (invoiceOrderLine !== null && invoiceOrderLine !== undefined) {
        const qty = invoiceOrderLine.qtyOrdered !== undefined && invoiceOrderLine.qtyOrdered != null
            ? invoiceOrderLine.qtyOrdered : invoiceOrderLine.properties["minimuM_QTY"];
        return {
            item_id:
                invoiceOrderLine.productErpNumber !== undefined && invoiceOrderLine.productErpNumber != null
                    ? invoiceOrderLine.productErpNumber.trim()
                    : invoiceOrderLine.productErpNumber,
            item_name:
                invoiceOrderLine.properties["longDescription"] !== undefined &&
                    invoiceOrderLine.properties["longDescription"] != null
                    ? invoiceOrderLine.properties["longDescription"]
                    : invoiceOrderLine.description,
            item_brand:
                invoiceOrderLine.packDescription !== undefined &&
                    invoiceOrderLine.packDescription["branD_SHORTDESC"] !== undefined &&
                    invoiceOrderLine.packDescription["branD_SHORTDESC"] != null
                    ? invoiceOrderLine.packDescription["branD_SHORTDESC"]
                    : "",
            item_category: categories.length > 0 ? categories[0] : "",
            item_category2: categories.length > 1 ? categories[1] : "",
            item_category3:
                categories.length > 2 ? categories[2] : invoiceOrderLine.properties["productcategory"] ?? "",
            item_variant: "", // product.availability != null && product.availability["message"] != null ? product.availability["message"] : '',
            item_list_name: listname,
            index: productIndex + 1,
            price:
                invoiceOrderLine.lineTotal != null && invoiceOrderLine.lineTotal !== undefined
                    ? invoiceOrderLine.lineTotal
                    : "",
            quantity: Number(qty),
            price_type: getProductMarketingTag(invoiceOrderLine),
        };
    }
}

export function createInvoiceOrderLineDataLayerItemUnAuth(
    invoiceOrderLine: any,
    categories: string[],
    listname: string,
    productIndex = 1,
): any {
    if (invoiceOrderLine !== null && invoiceOrderLine !== undefined) {
        return {
            item_id:
                invoiceOrderLine.productErpNumber !== undefined && invoiceOrderLine.productErpNumber != null
                    ? invoiceOrderLine.productErpNumber.trim()
                    : invoiceOrderLine.productErpNumber,
            item_name:
                invoiceOrderLine.properties["longDescription"] !== undefined &&
                    invoiceOrderLine.properties["longDescription"] != null
                    ? invoiceOrderLine.properties["longDescription"]
                    : invoiceOrderLine.description,
            item_brand:
                invoiceOrderLine.packDescription !== undefined &&
                    invoiceOrderLine.packDescription["branD_SHORTDESC"] !== undefined &&
                    invoiceOrderLine.packDescription["branD_SHORTDESC"] != null
                    ? invoiceOrderLine.packDescription["branD_SHORTDESC"]
                    : "",
            item_category: categories.length > 0 ? categories[0] : "",
            item_category2: categories.length > 1 ? categories[1] : "",
            item_category3:
                categories.length > 2 ? categories[2] : invoiceOrderLine.properties["productcategory"] ?? "",
            item_list_name: listname,
            index: productIndex + 1,
        };
    }
}

export function findCategoryNameforL1L2(): string {
    let categoryName = "";
    if (typeof window !== "undefined") {
        categoryName = window.location.pathname?.toLocaleLowerCase();
    }
    if (categoryName != null) {
        if (categoryName.split("/").length > 4) {
            categoryName = `${categoryName.split("/")[3]}_l2_${categoryName.split("/")[4]}`;
        } else if (categoryName.split("/").length > 3) {
            categoryName = categoryName.split("/")[3];
        } else {
            categoryName = "";
        }
    }
    return categoryName;
}

export function bannerGaTag(banner: BannerCarouselList): string {
    let categoryName = findCategoryNameforL1L2();
    const { imageAlternativeText, headerLineOne, headerLineTwo, backgroundImage } = banner;
    const imagename = backgroundImage ? backgroundImage.split("/")?.pop() : '';
    const img2 = imagename?.substring(0, imagename.lastIndexOf("."));
    if (categoryName == "" || categoryName == undefined) {
        categoryName = `home`;
    }
    let gatag = "";
    if (imageAlternativeText !== "" && imageAlternativeText !== undefined) {
        gatag = `${categoryName}_carousel_${imageAlternativeText}`;
    } else if (headerLineOne !== "" && headerLineOne !== undefined) {
        gatag = `${categoryName}_carousel_${headerLineOne}`;
    } else if (headerLineTwo !== "" && headerLineTwo !== undefined) {
        gatag = `${categoryName}_carousel_${headerLineTwo}`;
    } else if (img2 !== "" && img2 !== undefined) {
        gatag = `${categoryName}_carousel_${img2}`;
    } else {
        gatag = `${categoryName}_carousel`;
    }
    gatag = gatag?.toLocaleLowerCase().trim();
    gatag = gatag?.replace(/[&)#($:.',;*]/g, "");
    gatag = gatag?.replace(/  /g, "-");
    gatag = gatag?.replace(/ /g, "-");
    gatag = gatag?.replace("--", "-");

    return gatag;
}

export function bannerButtonGaTagLYT(banner: BannerCarouselList): string {
    const { bannerButtonText, isRewardInvitedUser, isRewardEnrolledUser } = banner;
    let tag = "";
    let buttonName = bannerButtonText;
    buttonName = buttonName?.toLocaleLowerCase().trim();
    buttonName = buttonName?.replace(/[&)#($:.',;*]/g, "");
    buttonName = buttonName?.replace(/  /g, "-");
    buttonName = buttonName?.replace(/ /g, "-");
    buttonName = buttonName?.replace("--", "-");
    if (!isRewardEnrolledUser && isRewardInvitedUser)
        tag = `ADI-Rewards_${buttonName}`;
    else if (isRewardEnrolledUser)
        tag = `ADI-Rewards_Banner_for_Enrolled_Users`;
    return tag;
}

export function bannerButtonGaTag(banner: BannerCarouselList): string {
    let categoryName = findCategoryNameforL1L2();
    if (categoryName == "" || categoryName == undefined) {
        categoryName = `home`;
    }
    const { imageAlternativeText, headerLineOne, headerLineTwo, backgroundImage, bannerButtonText } = banner;
    const imagename = backgroundImage.split("/")?.pop();
    const img2 = imagename?.substring(0, imagename.lastIndexOf("."));
    let gatagbutton = "";
    if (imageAlternativeText !== "" && imageAlternativeText !== undefined) {
        gatagbutton = `${categoryName}_carousel_${imageAlternativeText}_${bannerButtonText}`;
    } else if (headerLineOne !== "" && headerLineOne !== undefined) {
        gatagbutton = `${categoryName}_carousel_${headerLineOne}_${bannerButtonText}`;
    } else if (headerLineTwo !== "" && headerLineTwo !== undefined) {
        gatagbutton = `${categoryName}_carousel_${headerLineTwo}_${bannerButtonText}`;
    } else if (img2 !== "" && img2 !== undefined) {
        gatagbutton = `${categoryName}_carousel_${img2}_${bannerButtonText}`;
    } else {
        gatagbutton = `${categoryName}_carousel_${bannerButtonText}`;
    }

    gatagbutton = gatagbutton?.toLocaleLowerCase().trim();
    gatagbutton = gatagbutton?.replace(/[&)#($:.',;*]/g, "");
    gatagbutton = gatagbutton?.replace(/  /g, "-");
    gatagbutton = gatagbutton?.replace(/ /g, "-");
    gatagbutton = gatagbutton?.replace("--", "-");
    return gatagbutton;
}
export function bannerButtonGaTagV2(buttonTitle: string): string {
    let categoryName = findCategoryNameforL1L2();
    if (categoryName == "" || categoryName == undefined) {
        categoryName = `home`;
    }
    //const { imageAlternativeText, headerLineOne, headerLineTwo, backgroundImage, bannerButtonText } = banner;
    //const imagename = backgroundImage.split("/")?.pop();
    //const img2 = imagename?.substring(0, imagename.lastIndexOf("."));
    let gatagbutton = "";

    gatagbutton = `${categoryName}_carousel_${buttonTitle}`;
    gatagbutton = gatagbutton?.toLocaleLowerCase().trim();
    gatagbutton = gatagbutton?.replace(/[&)#($:.',;*]/g, "");
    gatagbutton = gatagbutton?.replace(/  /g, "-");
    gatagbutton = gatagbutton?.replace(/ /g, "-");
    gatagbutton = gatagbutton?.replace("--", "-");
    return gatagbutton;
}

export function getcartItemViewListFromStorage() {
    if (typeof window === "undefined") {
        return [];
    }

    return (JSON.parse(sessionStorage.getItem("cartItemViewList") || "[]") as CartItemsListDto[]).filter(
        (o: any) => typeof o === "object",
    );
}

export function addcartItemViewListToStorage(erpNumber: string, source: string) {
    if (
        typeof window === "undefined" ||
        !erpNumber ||
        erpNumber.trim().length === 0 ||
        !source ||
        source.trim().length === 0
    ) {
        return;
    }

    erpNumber = erpNumber.trim();
    source = source.trim();

    let cartItemViewList = getcartItemViewListFromStorage();
    const queryIndex = cartItemViewList.map(o => o.erpNumber).indexOf(erpNumber);
    if (queryIndex > -1) {
        cartItemViewList.splice(queryIndex, 1);
    }

    cartItemViewList.splice(0, 0, { erpNumber: erpNumber, viewListName: source, isFromProductLink: false });
    cartItemViewList = cartItemViewList.splice(0);

    sessionStorage.setItem("cartItemViewList", JSON.stringify(cartItemViewList));
}
